import { Sidebar } from '@/components/ui/Sidebar'
import { Header } from '@/components/ui/Header'
import { RightPanel } from '@/components/ui/RightPanel'
import { MainContent } from '@/components/layouts/MainContent'
import { useUIStore } from '@/stores'

export function MainLayout() {
  const { sidebarOpen, rightPanelOpen, activeView } = useUIStore()
  const showRightPanel = rightPanelOpen && !['settings', 'wallet', 'marketplace', 'app-builder', 'agent'].includes(activeView)

  return (
    <div className="synapsios-layout">
      <Header />
      <div className="synapsios-body">
        {sidebarOpen && <Sidebar />}
        <main className="main-content">
          <MainContent />
        </main>
        {showRightPanel && <RightPanel />}
      </div>
    </div>
  )
}
